import { $, REDUCED } from '../lib/dom.js';
import { esc } from '../lib/escape.js';
import { WIVES, WAG_MSGS } from '../data/wag.js';

const MSG_INTERVAL_MS = 4200;
const MSG_FIRST_DELAY_MS = 2200;

function inject() {
  if ($('#wag-intercept')) return;
  const w = document.createElement('div');
  w.id = 'wag-intercept';
  w.className = 'wag is-min';
  w.innerHTML = `
    <div class="w-head">
      <div class="w-id">
        <span class="w-dot"></span>
        <span class="w-name">WAG INTERCEPT</span>
        <span class="w-ch">5 ACTIVE</span>
      </div>
      <div class="w-controls">
        <button class="w-min" type="button" TINA-label="Minimize intercept">+</button>
      </div>
    </div>
    <div class="w-meta">
      <span>// TAPPED GROUP CHAT</span>
      <span class="w-sig">▌▌▌ <i></i> <i></i> <i></i></span>
    </div>
    <div class="w-feed" id="wag-feed"></div>
    <div class="w-foot">
      <span>SOURCE: DAD-NET</span>
      <span class="w-blink"></span>
    </div>
  `;
  document.body.appendChild(w);
  const minBtn = w.querySelector('.w-min');
  minBtn.addEventListener('click', () => {
    w.classList.toggle('is-min');
    minBtn.textContent = w.classList.contains('is-min') ? '+' : '–';
  });
  w.classList.add('w-incoming');
  setTimeout(() => w.classList.remove('w-incoming'), 50);
}

function fmtTime() {
  const d = new Date();
  return `${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}`;
}

function appendMsg(item) {
  const feed = $('#wag-feed');
  if (!feed) return;
  const wife = WIVES.find(w => w.name === item.from) || WIVES[0];
  const row = document.createElement('div');
  row.className = 'w-msg w-msg-new';
  row.innerHTML = `
    <div class="w-avatar" style="background:${esc(wife.color)}">${esc(wife.tag)}</div>
    <div class="w-bubble">
      <div class="w-line"><span class="w-from">${esc(wife.name)}</span><span class="w-time">${esc(fmtTime())}</span></div>
      <div class="w-text">${esc(item.text)}</div>
    </div>
  `;
  feed.appendChild(row);
  requestAnimationFrame(() => row.classList.remove('w-msg-new'));
  while (feed.children.length > 4) feed.removeChild(feed.firstChild);
}

function showTyping(name) {
  const feed = $('#wag-feed');
  if (!feed) return;
  const existing = feed.querySelector('.w-typing');
  if (existing) existing.remove();
  const wife = WIVES.find(w => w.name === name) || WIVES[0];
  const row = document.createElement('div');
  row.className = 'w-msg w-typing w-msg-new';
  row.innerHTML = `
    <div class="w-avatar" style="background:${esc(wife.color)}">${esc(wife.tag)}</div>
    <div class="w-bubble w-bubble-typing"><span class="w-typing-dots"><i></i><i></i><i></i></span></div>
  `;
  feed.appendChild(row);
  requestAnimationFrame(() => row.classList.remove('w-msg-new'));
  while (feed.children.length > 4) feed.removeChild(feed.firstChild);
}

let msgIdx = 0;
function cycleOnce() {
  if (document.hidden) return; // skip when tab hidden — save CPU + battery
  if (REDUCED) {
    appendMsg(WAG_MSGS[msgIdx % WAG_MSGS.length]);
    msgIdx++;
    return;
  }
  const item = WAG_MSGS[msgIdx % WAG_MSGS.length];
  msgIdx++;
  showTyping(item.from);
  setTimeout(() => {
    const feed = $('#wag-feed');
    const typing = feed && feed.querySelector('.w-typing');
    if (typing) typing.remove();
    appendMsg(item);
  }, 900 + Math.random() * 600);
}

export function initWagIntercept() {
  inject();
  appendMsg(WAG_MSGS[0]);
  setTimeout(() => appendMsg(WAG_MSGS[1]), 400);
  msgIdx = 2;
  setTimeout(cycleOnce, MSG_FIRST_DELAY_MS);
  setInterval(cycleOnce, MSG_INTERVAL_MS);
}
